export default "__VITE_ASSET__CtSG0fZC__"